import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  login: (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data),
  register: (email, password, name) => api.post("/auth/register", { email, password, name }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const cityApi = {
  list: (params = {}) => api.get("/cities", { params }).then((r) => r.data),
  update: (id, body) => api.patch(`/admin/cities/${id}`, body).then((r) => r.data),
};

export const categoryApi = {
  list: (params = {}) => api.get("/categories", { params }).then((r) => r.data),
  create: (body) => api.post("/admin/categories", body).then((r) => r.data),
  update: (id, body) => api.patch(`/admin/categories/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/admin/categories/${id}`).then((r) => r.data),
};

export const eventApi = {
  list: (params = {}) => api.get("/events", { params }).then((r) => r.data),
  adminList: (params = {}) => api.get("/admin/events", { params }).then((r) => r.data),
  get: (id) => api.get(`/events/${id}`).then((r) => r.data),
  create: (body) => api.post("/admin/events", body).then((r) => r.data),
  update: (id, body) => api.patch(`/admin/events/${id}`, body).then((r) => r.data),
  remove: (id) => api.delete(`/admin/events/${id}`).then((r) => r.data),
  scrape: (url) => api.post("/admin/events/scrape", { url }).then((r) => r.data),
};

export const otpApi = {
  send: (phone) => api.post("/otp/send", { phone }).then((r) => r.data),
  verify: (phone, otp) => api.post("/otp/verify", { phone, otp }).then((r) => r.data),
};
